import { call, put, select, takeLatest, all } from "redux-saga/effects";
import axiosInstance from "utils/axiosInstance";

// Redux Actions
import { 
  STORE_DETAILS_FETCH_REQUEST,
  STORE_DETAILS_FETCH_SUCCESS,
  STORE_DETAILS_FETCH_FAILURE,
} from "./actionTypes";
import { FETCH_MISSING_IMAGES } from "store/imageMap/actionTypes";

function* fetchStoreDetailsSaga(action) {
  const { storeId } = action;

  try {

    const [profileRes, topicListRes, expRes] = yield all([
      call(axiosInstance.get, `/knovia/myInfo/stores/${storeId}/storeInfoProfile`),
      call(axiosInstance.get, `/knovia/myInfo/stores/${storeId}/getTopicsInStore`),
      call(axiosInstance.get, `/knovia/myInfo/stores/${storeId}/experience`)
    ]);

    const profile = profileRes.data;
    const topics = [...topicListRes.data].sort((a, b) => a.order - b.order);
    const levelData = expRes.data;
    const topicIds = topicListRes.data.map(t => t._id);

    // Collect all images to fetch
    const allFilenames = [
      profile.profileImage,
      profile.backgroundImage,
      ...topics.map(t => t.image)
    ].filter(Boolean);

    // Trigger shared image loader
    yield put({ type: FETCH_MISSING_IMAGES, payload: { filenames: allFilenames, size: 'original' } });

    // Store other non-image data
    yield put({
      type: 'STORE_DETAILS_FETCH_SUCCESS',
      storeId,
      payload: { profile, topicIds, levelData }
    });

    for (const topic of topicListRes.data) {
      const existingTopic = yield select(state => state.topicDetails.topics[topic._id]);

      if (!existingTopic) {
        // Only prefill if not loaded yet
        yield put({
          type: 'TOPIC_DETAILS_FETCH_SUCCESS',
          topicId: topic._id,
          payload: {
            topicInfo: topic,
            questionSetIds: []
          }
        });
      }

      // Always fetch full topic details (topicInfo + questionSets)
      yield put({
        type: 'TOPIC_DETAILS_FETCH_REQUEST',
        topicId: topic._id
      });
    }
  } catch (err) {
    console.error('[fetchStoreDetailsSaga] Error:', err);
    yield put({
      type: 'STORE_DETAILS_FETCH_FAILURE',
      error: err.message || 'Fetch failed'
    });
  }
}

function* storeDetailsSaga() {
  yield takeLatest(STORE_DETAILS_FETCH_REQUEST, fetchStoreDetailsSaga);
}

export default storeDetailsSaga;


